import { syncWechatWorkUsers } from "@/service/appList";
const SYNC_COOLDOWN_DURATION = 30 * 1000;
export default {
  name: "AppDetailContactSync",
  props: {
    appId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      syncLoading: false,
      syncCooldown: false,
      syncCooldownTimer: null
    };
  },
  methods: {
    // 同步成功后保留十秒冷却期，避免用户短时间内重复创建异步任务。
    startSyncCooldown() {
      clearTimeout(this.syncCooldownTimer);
      this.syncCooldown = true;
      this.syncCooldownTimer = setTimeout(() => {
        this.syncCooldown = false;
        this.syncCooldownTimer = null;
      }, SYNC_COOLDOWN_DURATION);
    },
    // 发起当前企微同步应用的异步通讯录同步任务，并拦截请求中或冷却期内的重复操作。
    async syncContacts() {
      if (this.syncLoading || this.syncCooldown) {
        this.$Message.warning($t("jn4daud", "正在发起同步，请勿重复发起"));
        return;
      }
      this.syncLoading = true;
      try {
        const res = await syncWechatWorkUsers(this.appId);
        if (res.data && res.data.result === 0) {
          this.startSyncCooldown();
          this.$Message.success($t("cldm4h5", "同步已发起"));
        }
        // 业务失败由全局请求拦截器展示后端提示，避免重复弹出消息。
      } finally {
        this.syncLoading = false;
      }
    }
  },
  beforeDestroy() {
    // 组件离开页面时清理冷却计时器，避免销毁后继续更新组件状态。
    clearTimeout(this.syncCooldownTimer);
  }
};